import { useEffect, useState } from "react";
import { PlayCircle } from "lucide-react";
import { API, imgSrc } from "@/lib/api";
import VideoPlayer from "@/components/VideoPlayer";
import ExpandableDescription from "@/components/ExpandableDescription";
import { usePageMeta } from "@/lib/seo";

export default function Videos() {
  const [videos, setVideos] = useState(null);
  usePageMeta("Video Produk", "Kumpulan video produk, panduan, dan aktivitas NAWADAH by NDH Official.");

  useEffect(() => {
    API.get("/videos").then((response) => setVideos(response.data || [])).catch(() => setVideos([]));
  }, []);

  return (
    <div className="min-h-screen bg-navy-dark text-white">
      <section className="relative border-b border-gold/20 bg-maritime-grid py-20 noise-overlay" data-testid="video-header">
        <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse at 15% 0%, rgba(201,162,39,0.12) 0%, transparent 55%)" }} />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.3em] text-gold">Galeri Video</p>
          <h1 className="font-display text-4xl tracking-tight sm:text-5xl">Video NAWADAH</h1>
          <p className="mt-4 max-w-2xl text-sm text-slate-400 sm:text-base">Lihat produk, panduan, dan informasi terbaru dari NAWADAH by NDH Official.</p>
        </div>
      </section>

      <section className="relative bg-rope-pattern py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-testid="video-grid">
            {(videos || []).map((item) => (
              <article key={item.id} className="card-maritime-surface overflow-hidden rounded-md" data-testid={`video-card-${item.id}`}>
                <div className="aspect-video bg-black">
                  <VideoPlayer url={item.video_url} title={item.title} poster={item.thumbnail_url ? imgSrc(item.thumbnail_url) : ""} className="h-full w-full object-cover" />
                </div>
                <div className="p-6">
                  <p className="mb-2 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-gold"><PlayCircle className="h-3.5 w-3.5" /> Video NAWADAH</p>
                  <h2 className="line-clamp-2 font-display text-xl leading-snug">{item.title}</h2>
                  <ExpandableDescription
                    text={item.description}
                    collapsedLines={3}
                    className="mt-2 text-sm leading-relaxed text-slate-400"
                  />
                </div>
              </article>
            ))}
          </div>
          {videos && videos.length === 0 && <p className="text-sm text-slate-400">Video akan segera hadir.</p>}
        </div>
      </section>
    </div>
  );
}
